import { createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-35179b88")

_pushScopeId("data-v-35179b88")
const _hoisted_1 = { class: "col-12 col-sm-12 col-xl" }
const _hoisted_2 = { class: "card-body d-flex justify-content-center text-center flex-column p-8" }
const _hoisted_3 = { class: "symbol symbol-60px mb-6" }
const _hoisted_4 = { class: "fs-5 fw-bolder mb-2 text-truncate px-2" }
const _hoisted_5 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_6 = { class: "fs-7 fw-bold text-gray-400 mt-auto" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "card h-100 team-material-card",
      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('open')))
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("a", {
          href: "#",
          class: "text-gray-800 text-hover-primary d-flex flex-column",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('open')), ["prevent"]))
        }, [
          _createVNode("div", _hoisted_3, [
            _createVNode("img", {
              src: `media/svg/files/${_ctx.fileType}.svg`,
              alt: ""
            }, null, 8, ["src"])
          ]),
          _createVNode("div", _hoisted_4, _toDisplayString(_ctx.fileTitle), 1)
        ]),
        (_ctx.indexingStatusLabel)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("span", {
                class: ["badge", _ctx.indexingStatusClass]
              }, _toDisplayString(_ctx.indexingStatusLabel), 3)
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.createdAt), 1),
        (_ctx.canManage)
          ? (_openBlock(), _createBlock("div", {
              key: 1,
              class: "d-flex justify-content-center gap-2 mt-3",
              onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
            }, [
              (_ctx.canPublish)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-sm btn-light-success",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('publish')))
                  }, "Publish"))
                : _createCommentVNode("", true),
              _createVNode("button", {
                type: "button",
                class: "btn btn-sm btn-light-primary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('rename')))
              }, "Rename"),
              _createVNode("button", {
                type: "button",
                class: "btn btn-sm btn-light-danger",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('delete')))
              }, "Delete")
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
})